// src/lib/sessionStore.js
// localStorage-based workout session persistence with auto-expiry

const KEYS = {
  PALESTRA: 'hybrid_palestra_session',
  HYROX:    'hybrid_hyrox_session',
  CORSA:    'hybrid_corsa_session',
}
const MAX_AGE = 24 * 60 * 60 * 1000 // 24 ore

export const sessionStore = {
  save(type, data) {
    try {
      localStorage.setItem(KEYS[type], JSON.stringify({ data, ts: Date.now() }))
    } catch (e) {
      console.warn('[sessionStore] save failed:', e)
    }
  },

  load(type) {
    try {
      const raw = localStorage.getItem(KEYS[type])
      if (!raw) return null
      const { data, ts } = JSON.parse(raw)
      if (Date.now() - ts > MAX_AGE) {
        this.clear(type)
        return null
      }
      return data
    } catch {
      return null
    }
  },

  clear(type) {
    localStorage.removeItem(KEYS[type])
  },

  clearAll() {
    Object.values(KEYS).forEach(k => localStorage.removeItem(k))
  },

  hasSession(type) {
    return this.load(type) !== null
  },
}
